// @ts-nocheck

export const MINIMUM_BETS_FOR_BET_SLIDER_PRESENTATION = 3;
export const MINIMUM_OUTCOMES_FOR_BET_SLIDER_PRESENTATION = 3;
